export default __webpack_public_path__ + "static/media/find_agent.6eab34ba.svg";